<template>
  <div>
    <div v-if="editing">
      <div class="input-group mb-3">
        <input type="text" class="form-control" v-model="newTagName" @blur="saveTag" v-on:keyup.enter="saveTag" placeholder='Tag Name'>
        <div class="input-group-append">
          <button class="btn btn-primary" type="button" @click="saveTag">Save</button>
        </div>
      </div>
    </div>
    <span v-else>
      <i class="material-icons pointer x-small-icon" data-toggle="dropdown">edit</i>
      <div class="dropdown-menu dropdown-menu-left">
        <a v-if="!this.tag.archived_at" class="dropdown-item text-primary" href="#" @mousedown="focus">Edit</a>
        <a v-if="!this.tag.archived_at" class="dropdown-item text-primary" href="#" data-toggle="modal" :data-target="'#moveModal' + tag.id">Move to {{ $t("projects.parent") }}</a>
        <a v-if="isArchived()" class="pointer dropdown-item text-danger"  @click="restoreTag()">Unarchive {{ $t("tags.singular") }}</a>
        <a v-else class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#archiveModal' + tag.id">Archive {{ $t("tags.singular") }}</a>
        <a v-if="isTrashed()" class="pointer dropdown-item text-danger"  @click="untrashTag()">Remove from Trash</a>
        <a v-else class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#trashModal' + this.tag.id">Trash {{ $t("tags.singular") }}</a>
      </div>
      <div class="modal fade" :id="'archiveModal' + this.tag.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure you want to {{ actionName.toLowerCase() }} this {{ $t("tags.singular").toLowerCase() }}?</h5>
              </div>
              <div class="modal-body">
                <div> Are you sure you want to {{ actionName.toLowerCase() }}
                  <em>
                    {{this.tag.name}}
                  </em>
                  ?
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button v-if="this.tag.archived_at" type="button" class="btn btn-primary" @click="restoreTag()">{{ actionName }} {{ $t("tags.singular") }}</button>
                <button v-else type="button" class="btn btn-primary" @click="archiveTag()">{{ actionName }} {{ $t("tags.singular") }}</button>
              </div>
            </div>
          </div>
      </div>
      <div class="modal fade" :id="'moveModal' + this.tag.id">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Are you sure you want to move this {{ $t("tags.singular").toLowerCase() }}?</h5>
            </div>
            <div class="modal-body">
              <div> Are you sure you want to move
                <em>
                  {{this.tag.name}}
                </em>
                to the {{ $t("projects.parent") }}?
              </div>
              <div class="form-group mt-3">
          <label for="projectSelect">Select area:</label>
                <select id="projectSelect" v-model="selectedProjectAreaId" class="form-control">
                  <option v-for="project in allProjectAreas" :key="project.id" :value="project.id">
                    {{ project.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" @click="moveTagToProject" :disabled="!selectedProjectAreaId">
                Move to {{ $t("projects.parent") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" :id="'trashModal' + this.tag.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure you want to {{ trashActionName.toLowerCase() }} this {{ $t("tags.singular").toLowerCase() }}?</h5>
              </div>
              <div class="modal-body">
                <div> Are you sure you want to {{ trashActionName.toLowerCase() }}
                  <em>
                    {{this.tag.name}}
                  </em>
                  ?
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button v-if="this.tag.archived_at" type="button" class="btn btn-primary" @click="untrashTag()">{{ trashActionName }} {{ $t("tags.singular") }}</button>
                <button v-else type="button" class="btn btn-primary" @click="trashTag()">{{ trashActionName }} {{ $t("tags.singular") }}</button>
              </div>
            </div>
          </div>
      </div>
      <router-link :to="{ name: 'tags', params: { tag_name: this.tag.name } }" class="text-secondary">
        {{this.tag.name}} <i v-if="tag.deleted_at" class="material-icons x-small-icon">delete</i>
      </router-link>
    </span>
  </div>
</template>

<script>
import api from "api";

export default {
  components: {
  },
  props: {
    tag: Object
    },
  data() {
    return {
      editing: false,
      newTagName: this.tag.name,
      selectedProjectAreaId: null,
      allProjectAreas: this.$store.state.project_areas,
    };
  },
  computed: {
    archived_at: function() {
      return new Date()
    },
    actionName: function () {
      return this.tag.archived_at === null ? 'Archive' : 'Unarchive'
    },
    trashActionName: function () {
      return this.tag.deleted_at === null ? 'Trash' : 'Untrash'
    }, 
  },
  created() {
   this.originalTagName = this.tagName
  },
  methods: {
    isArchived(){
      return this.tag.archived_at
    },
    isTrashed(){
      return this.tag.deleted_at
    },        
    titleContent(){
      if(this.containerExpanded){
        return this.titleText
      } else {
        return this.titleText.length > 75 ? `${this.titleText.substring(0, 75)}...` : this.titleText;
      }
    },
    saveTag(){
      this.editing = false;
      api.updateTag(this.tag.name, this.newTagName, '').then(response => {
      });
    },
    archiveTag(){
      this.editing = false;
      var tagId = this.tag.id
      $('#archiveModal' + tagId).modal('hide')
      api.updateTag(this.tag.name, this.newTagName, this.archived_at).then(response => {
        store.commit('removeIdFromSortedGroup', { name: 'tags', id: tagId })
        store.commit('addIdToSortedGroup', { name: 'archived_tags', id: tagId })
      });
    },
    restoreTag(){
      var tagId = this.tag.id
      $('#archiveModal' + tagId).modal('hide')
      this.editing = false;
      api.restoreTag(this.tag.id).then(response => {
        store.commit('addIdToSortedGroup', { name: 'tags', id: tagId })
        store.commit('removeIdFromSortedGroup', { name: 'archived_tags', id: tagId })
      });
    },
    trashTag() {
      this.editing = false;
      var tagId = this.tag.id
      $('#trashModal' + tagId).modal('hide')
      api.trashTag(tagId).then(response => {
        store.commit('removeIdFromSortedGroup', { name: 'tags', id: tagId })
        store.commit('addIdToSortedGroup', { name: 'archived_tags', id: tagId })
      });
    },
    untrashTag() {
      this.editing = false;
      var tagId = this.tag.id
      $('#trashModal' + tagId).modal('hide')
      api.untrashTag(tagId).then(response => {
        store.commit('addIdToSortedGroup', { name: 'tags', id: tagId })
        store.commit('removeIdFromSortedGroup', { name: 'archived_tags', id: tagId })
      });
    },    
    blur(event){
      this.saveTitle()
    },
    focus(event){
      this.editing = true;
    },
    tagSlug(){
      return this.tagName.replace(/ /g, '_');
    },
    moveTagToProject() {
      if (this.selectedProjectAreaId) {
        const tagId = this.tag.id;
        $('#moveModal' + tagId).modal('hide');
        api.moveTagToProject(tagId, this.selectedProjectAreaId).then(response => {
          // store.commit('addIdToSortedGroup', { name: 'tags', id: tagId })
          store.commit('removeIdFromSortedGroup', { name: 'tags', id: tagId })

          this.$router.push({ name: 'category', params: {id: this.selectedProjectAreaId} })
        });
      }
    }
  }
}
</script>
